import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React, { useEffect, useRef, useState } from 'react';
import usePagebuilder from '../../../../../../../hooks/pagebuilder/usePagebuilder';
import { useBooth } from '../../../../../../../hooks/useBooth';
import { Booth } from '../../../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../../../reduxToolkit/typedRedux';
import ImportModal from '../../../../../../account/ImportModal';
import InlineEditButton from '../../../../../pageBuilder/InlineEditButton';
import BigBoothPreview from '../BigBoothPreview';
import BigBoothEdit from './index';
import { useDispatch } from 'react-redux';
import { setIsBoothEditMode } from '../../../../../../../reduxToolkit/slices/adminSlice';

interface BoothTabProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  booth: Booth;
  setHeight: (h?: number) => void;
}

const BoothTab = ({ booth, setHeight, ...props }: BoothTabProps) => {
  const user = useSelector((state) => state.common.user);
  const isBoothEditMode = useSelector((state) => state.admin.isBoothEditMode);
  const [importModal, setImportModal] = useState<Booth>();

  const { t } = useTranslation();
  const { hasEditPrivilege } = useBooth();
  const { canEditBooth } = usePagebuilder();
  const dispatch = useDispatch();
  const ref = useRef<HTMLDivElement>(null);

  const hasPrivilege = !!booth && !!user && hasEditPrivilege(booth, user);

  function toggleEditMode(isEditMode: boolean) {
    dispatch(setIsBoothEditMode(isEditMode));
  }

  useEffect(() => {
    return () => {
      dispatch(setIsBoothEditMode(false));
    };
  }, []);

  useEffect(() => {
    setHeight(ref.current?.getBoundingClientRect().height);
  }, [ref.current?.getBoundingClientRect().height]);
  return (
    <>
      <ImportModal booth={importModal} onClose={() => setImportModal(undefined)} />
      <div {...props} ref={ref} className="relative" style={{ minHeight: '70vh' }}>
        {canEditBooth(booth) && (
          <div className="absolute z-40 flex flex-row gap-2 text-black top-2 right-2">
            <Tooltip title="Import">
              <div
                className="z-40 grid w-10 h-10 text-black bg-white bg-opacity-75 rounded-full cursor-pointer place-items-center"
                onClick={() => setImportModal(booth)}>
                <FontAwesomeIcon icon={faDownload} size="lg" />
              </div>
            </Tooltip>
            <InlineEditButton
              isEditMode={isBoothEditMode}
              setIsEditMode={toggleEditMode}
              className="z-40 "
              tooltip={t('pagebuilder:booths-edit-details')}
              forceShow={hasPrivilege}
            />
          </div>
        )}
        {isBoothEditMode ? <BigBoothEdit booth={booth} /> : <BigBoothPreview booth={booth} />}
      </div>
    </>
  );
};

export default BoothTab;
